module.exports = __webpack_public_path__ + "static/media/2.905e6649.jpg";